const Description = ({
  text
}) => {
  const base = 'w-full max-w-[640px] text-bodyMobile md:text-bodyDesktop text-umber text-center font-chivoMono'

  return (
    <p className={base}>
      {text}
    </p>
  )
}

export default Description